<template>
    <div>
        <label>
            <span>File</span>
            <span v-if="ahref"> - <a :href="ahref" target="_blank">Open in new tab</a></span>
        </label>
        <div class="dropzone" :class="[error ? 'bd-red' : '']" @dragover.prevent="dragOver" @dragleave="dragLeave" @drop.prevent="dropFile" @click="fileSelect">
            <div v-if="showProgressBar" class="progress w-75">
                <div class="progress-bar bg-info" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100" :style="'width:' + progress + '%'">
                    {{ progress }}%
                </div>
            </div>
            <div v-else-if="error">
                <div class="placeholder-text text-danger">{{ error }}</div>
            </div>
            <div v-else-if="!file">
                <div class="placeholder-text text-muted">Drag your file or click to select</div>
            </div>
            <div v-else>
                <span class="placeholder-text text-muted">{{ file.name }}</span>
            </div>
            <input
                type="file"
                ref="fileInput"
                @change="fileChange"
                style="display: none"
            />
        </div>
    </div>
</template>

<script>
import axios from 'axios';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default {
    name: 'UploadFile',
    props: {
        isLocal: { type:Boolean, required:true },
        document: { type:Object, default:null, required:false },
        uploadError: { type:String, default:'', required:false },
    },
    data() {
        return {
            file: null,
            ahref: null,
            error: null,
            progress: 0,
            showProgressBar: false,
        }
    },
    watch: {
        uploadError(newValue) {
            this.error = newValue;
        }
    },
    mounted() {
        if(! this.error) {
            if(this.document?.filename) {
                this.file = new File([""], this.document.filename);

                axios.post("/api/file-url", {
                    key: this.document.key,
                    filename: this.document.filename,
                }).then((response) => {
                    this.ahref = response.data.url;
                });
            }
        }
    },
    methods: {
        dragOver(e) {
            e.preventDefault();
        },
        dragLeave(e) {
            e.preventDefault();
        },
        dropFile(e) {
            e.preventDefault();
            let files = e.dataTransfer.files;

            if(files.length > 1) {
                this.reset();
                this.error = 'Only one file is allowed to be uploaded';

                return;
            }

            if (files.length) {
                const file = files[0];
                this.uploadDocument(file);
            }
        },
        fileSelect() {
            this.$refs.fileInput.click();
        },
        fileChange(event) {
            const file = event.target.files[0];
            this.uploadDocument(file);
        },
        reset() {
            this.file = null;
            this.ahref = null;
            this.error = '';
            this.progress = 0;
            this.showProgressBar = false;
        },
        simulateUploadProgress(file) {
            return new Promise((resolve, reject) => {
                let progress = 0;
                const interval = setInterval(() => {
                    progress += 1;
                    this.progress = progress;
                    if (progress >= 100) {
                        clearInterval(interval);
                        this.showProgressBar = false;
                        this.file = file;
                        resolve();
                    }
                }, 20);
            });
        },
        getContentType(file) {

            return file.name.endsWith('.msg') ? 'application/vnd.ms-outlook' : file.type;
        },
        async uploadDocument(file) {
            window.dispatchEvent(new Event('disable-form-submit'));
            this.reset();
            this.showProgressBar = true;

            try {
                //get signed url
                const response = await axios.post("/api/signed-url", {
                    size: file.size,
                    content_type: this.getContentType(file),
                });

                // upload file
                if(! this.isLocal) {
                    await axios.put(response.data.url, file, {
                        headers: response.data.headers,
                        onUploadProgress: (e) => {
                            this.progress = Math.round((e.loaded * 100) / e.total);
                            if(this.progress == 100) {
                                this.showProgressBar = false;
                                this.file = file;
                            }
                        },
                    });
                } else {
                    await this.simulateUploadProgress(file);
                }

                // handle upload in parent component
                this.$emit('upload', {
                    'filename': file.name,
                    'key': response.data.key,
                    'size': file.size,
                    'content_type': this.getContentType(file),
                });

                // get file url
                const fileUrlResponse = await axios.post("/api/file-url", {
                    key: response.data.key,
                    filename:  file.name
                });

                this.ahref = fileUrlResponse.data?.url;
                window.dispatchEvent(new Event('enable-form-submit'));
            } catch (err) {
                this.reset();
                this.error = 'Something went wrong, please refresh the page and try again';
                window.dispatchEvent(new Event('enable-form-submit'));
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.dropzone {
  border: 2px dashed #ccc;
  border-radius: 5px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  position: relative;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  &.bd-red {
    border: 2px dashed #e3342f;
  }
}

.placeholder-text {
  text-align: center;
  width: 100%;
}
</style>